import React, { useContext} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlay } from '@fortawesome/free-regular-svg-icons'
import { faPause } from '@fortawesome/free-solid-svg-icons'
import { ClockContext } from 'contexts/TimerAppContexts/ClockContext'

const ButtonClock = () => {
    const { clockState, setClockState, countDown, disableBtn, setDisableBtn} = useContext(ClockContext)

    const handleButtonClick = ()=>{
        if(countDown!==0){
            setClockState(!clockState)
        } else{
            setDisableBtn(true)
        }
    }



    return (
        <div className='button-container'>
            <button className={`button-clock ${clockState ? 'active' : ''}`} disabled={disableBtn} onClick={handleButtonClick}>
                <FontAwesomeIcon className='btn-icon' icon={clockState ? faPause : faCirclePlay} />
            </button>
        </div>
    )
}

export default ButtonClock